import React, { createContext, useMemo } from "react";
import { ThemeProvider as ThemeProviderOrigin } from "@mui/material/styles";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export const ThemeContext = createContext({
  toggleColorMode: () => {},
});

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = React.useState("light");
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        console.log("toggle");
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const theme = useMemo(() => {
    const themeOptions = {
      palette: {
        mode,
        primary: {
          main: "#C73866",
        },
        secondary: {
          main: "#9aacb8",
          dark: "#3c455c",
        },
      },
      typography: {
        fontFamily: [
          "-apple-system",
          "BlinkMacSystemFont",
          '"Segoe UI"',
          "Roboto",
          '"Helvetica Neue"',
          "Arial",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(","),
      },
    };

    let theme = createTheme(themeOptions);
    theme = responsiveFontSizes(theme);
    return theme;
  }, [mode]);

  return (
    <ThemeContext.Provider value={colorMode}>
      <ThemeProviderOrigin theme={theme}>{children}</ThemeProviderOrigin>
    </ThemeContext.Provider>
  );
};
